var _jsxFileName = "/repo/packages/webassets/src/components/BasePage/BasePageHead.js",
  _this = this;
import React from 'react';
import PropTypes from 'prop-types';
import Helmet from '../Helmet';
var BasePageHead = function BasePageHead(_ref) {
  var isPrivateLabel = _ref.isPrivateLabel;
  return /*#__PURE__*/React.createElement(Helmet, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 6,
      columnNumber: 3
    }
  }, /*#__PURE__*/React.createElement("title", {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 7,
      columnNumber: 5
    }
  }, "Welcome to SurveyMonkey!"), /*#__PURE__*/React.createElement("meta", {
    name: "keywords",
    content: "SurveyMonkey,online surveys,online survey,web surveys, web survey,market research,free,research,stats,statistics,polls,voting,analyze,tool,decisions,planning,strategy,Community,forms,formsite,workgroups,cgi,database",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 8,
      columnNumber: 5
    }
  }), /*#__PURE__*/React.createElement("meta", {
    name: "description",
    content: "Create and publish online surveys in minutes, and view results graphically and in real time. SurveyMonkey provides free online questionnaire and survey software.",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 12,
      columnNumber: 5
    }
  }), /*#__PURE__*/React.createElement("meta", {
    charset: "utf-8",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 16,
      columnNumber: 5
    }
  }), /*#__PURE__*/React.createElement("meta", {
    name: "msapplication-config",
    content: "none",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 17,
      columnNumber: 5
    }
  }), /*#__PURE__*/React.createElement("meta", {
    name: "author",
    content: "SurveyMonkey",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 18,
      columnNumber: 5
    }
  }), isPrivateLabel ? /*#__PURE__*/React.createElement("link", {
    rel: "shortcut icon",
    href: "https://cdn.smassets.net/assets/cms/cc/app/static/momentive-favicon.ico",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 21,
      columnNumber: 9
    }
  }) : [/*#__PURE__*/React.createElement("link", {
    rel: "apple-touch-icon",
    href: "/apple-touch-icon-precomposed.png",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 27,
      columnNumber: 9
    },
    key: "0"
  }), /*#__PURE__*/React.createElement("link", {
    rel: "apple-touch-icon",
    sizes: "57x57",
    href: "/apple-touch-icon-57x57-precomposed.png",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 28,
      columnNumber: 9
    },
    key: "1"
  }), /*#__PURE__*/React.createElement("link", {
    rel: "apple-touch-icon",
    sizes: "60x60",
    href: "/apple-touch-icon-60x60-precomposed.png",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 33,
      columnNumber: 9
    },
    key: "2"
  }), /*#__PURE__*/React.createElement("link", {
    rel: "apple-touch-icon",
    sizes: "72x72",
    href: "/apple-touch-icon-72x72-precomposed.png",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 38,
      columnNumber: 9
    },
    key: "3"
  }), /*#__PURE__*/React.createElement("link", {
    rel: "apple-touch-icon",
    sizes: "76x76",
    href: "/apple-touch-icon-76x76-precomposed.png",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 43,
      columnNumber: 9
    },
    key: "4"
  }), /*#__PURE__*/React.createElement("link", {
    rel: "apple-touch-icon",
    sizes: "114x114",
    href: "/apple-touch-icon-114x114-precomposed.png",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 48,
      columnNumber: 9
    },
    key: "5"
  }), /*#__PURE__*/React.createElement("link", {
    rel: "apple-touch-icon",
    sizes: "120x120",
    href: "/apple-touch-icon-120x120-precomposed.png",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 53,
      columnNumber: 9
    },
    key: "6"
  }), /*#__PURE__*/React.createElement("link", {
    rel: "apple-touch-icon",
    sizes: "144x144",
    href: "/apple-touch-icon-144x144-precomposed.png",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 58,
      columnNumber: 9
    },
    key: "7"
  }), /*#__PURE__*/React.createElement("link", {
    rel: "apple-touch-icon",
    sizes: "152x152",
    href: "/apple-touch-icon-152x152-precomposed.png",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 63,
      columnNumber: 9
    },
    key: "8"
  }), /*#__PURE__*/React.createElement("link", {
    rel: "apple-touch-icon",
    sizes: "180x180",
    href: "/apple-touch-icon-180x180-precomposed.png",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 68,
      columnNumber: 9
    },
    key: "9"
  }), /*#__PURE__*/React.createElement("link", {
    rel: "shortcut icon",
    href: "/favicon.ico",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 73,
      columnNumber: 9
    },
    key: "10"
  })]);
};
BasePageHead.propTypes = {
  isPrivateLabel: PropTypes.bool
};
BasePageHead.defaultProps = {
  isPrivateLabel: false
};
export default BasePageHead;
//# sourceMappingURL=BasePageHead.js.map